<template>
    <div id="sub-users" class="main-content">
      <the-header :title="t('Sub-users')" :buttons="headerButtons"/>
      <div class="intro-text" v-html="t('_subUsersText')"></div>
      <div class="intro-text">{{t('Your PIN')}}: <span class="pin">{{securityPin}}</span></div>

      <data-grid :settings="grid"
                   ref="dataGrid"
                   :storeDispatchList="listData"
                   :page="parseInt($route.params.page)"
                   v-on:button-delete="deleteItem($event)"
                   v-on:button-block="blockItem($event)"
                   v-on:button-un-block="unblockItem($event)"
                   v-on:changePage="$router.push({name: 'subUsersList', params: {page: $event}})"
        />
    </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import DataGrid from '../../../core/DataGrid/DataGrid'

    export default {
        components: {
            TheHeader,
            DataGrid
        },
        methods: {
            goToChangePwd() {
                this.$router.push({name: 'subUserEdit', params: {id: item.id, page: 'base'}});
            },
            listData(params) {
                params.type = 'nurses';
                return this.$store.dispatch('users/list', params);
            },
            openItem(item) {
                this.$router.push({name: 'subUserEdit', params: {id: item.id, page: 'base'}});
            },
            deleteItem(item) {
                this.$store.dispatch('users/remove', item.id).then(response => {
                    this.$refs.dataGrid.fetchData();
                    this.$store.dispatch('alert/success', 'Sub-user was deleted')
                });
            },
            blockItem(item) {
                item.blocked = true;
                this.$store.dispatch('users/update', item).then(response => {
                    //this.$refs.dataGrid.fetchData();
                    this.$store.dispatch('alert/success', this.t('Sub-user was blocked'));
                });
            },
            unblockItem(item) {
                item.blocked = false;
                this.$store.dispatch('users/update', item).then(response => {
                    //this.$refs.dataGrid.fetchData();
                    this.$store.dispatch('alert/success', this.t('Sub-user was un-blocked'));
                });
            }
        },
        mounted() {
            this.securityPin = this.$store.getters['account/userStore'].getLoggedUser().getSecurityPin();
        },
        data() {
            return {
                securityPin: '',
                headerButtons: [
                    {
                        type: 'link',
                        name: this.t('Create sub-user'),
                        icon: 'plus',
                        styleClass: 'btn-success',
                        visible: () => {
                            return this.hasPermission('NurseTitan', 'C');
                        },
                        to: (item) => {
                            return {name: 'subUserCreate'};
                        }
                    }
                ],
                grid: {
                    buttons: [
                        {
                            type: 'link',
                            to: (item) => {
                                return {
                                    name: 'subUserEdit',
                                    params: {
                                        id: item.id,
                                    }
                                }
                            },
                            name: this.t('Edit'),
                            icon: 'eye',
                            styleClass: 'btn-primary btn-sm'
                        },
                        {
                            type: 'link',
                            to: (item) => {
                                return {
                                    name: 'changePassword',
                                    params: {
                                        id: item.id,
                                    }
                                }
                            },
                            name: this.t('Change password'),
                            icon: 'lock',
                            styleClass: 'btn-primary btn-sm'
                        },
                        {
                            type: 'action',
                            key: 'block',
                            name: this.t('Block'),
                            icon: 'ban',
                            styleClass: 'btn-danger btn-sm',
                            modalText: this.t('Do you really want to block this user?'),
                            visible: (item) => {
                                return this.hasPermission('NurseTitan', 'U') && item.blocked === false;
                            }
                        },
                        {
                            type: 'action',
                            key: 'un-block',
                            name: this.t('Un-block'),
                            icon: 'ban',
                            styleClass: 'btn-success btn-sm',
                            modalText: this.t('Do you really want to un-block this user?'),
                            visible: (item) => {
                                return this.hasPermission('NurseTitan', 'U') && item.blocked === true;
                            }
                        },
                        {
                            type: 'action',
                            key: 'delete',
                            name: this.t('Delete'),
                            icon: 'times',
                            styleClass: 'btn-danger btn-sm',
                            modalText: this.t('Do you really want to delete this user?'),
                            visible: () => {
                                return this.hasPermission('NurseTitan', 'U');
                            }
                        }
                    ],
                    columns: [
                        {
                            type: 'string',
                            name: this.t('Login'),
                            key: 'login',
                            filter: {
                                type: 'fulltext',
                            }
                        }, {
                            type: 'string',
                            name: this.t('Name'),
                            key: 'fullName',
                            sortField: ['firstname', 'lastname'],
                            filter: {
                                field: ['firstname', 'lastname'],
                                type: 'fulltext',
                                likeType: '%_like_',
                            },
                        }
                    ]
                },
            }
        }
    }
</script>
<style lang="scss">
  #sub-users {
    .intro-text {
      font-size: 0.9rem;
      margin-bottom: 1.2rem;
      .pin {
        font-size:1.1rem;
        color:green;
        font-weight: bold;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/private/subuser/SubUsers.vue